import React from 'react';
import { Sentry } from '../sentry';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      extra: {
        componentStack: errorInfo?.componentStack,
      },
    });

    // Keep console logging to aid debugging in development.
    // eslint-disable-next-line no-console
    console.error('Unhandled render error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
            backgroundColor: '#141414',
            color: '#ffffff',
            fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans',
          }}
        >
          <div>
            <h1 style={{ margin: '0 0 12px' }}>Une erreur s'est produite.</h1>
            <p style={{ marginBottom: '20px' }}>
              Veuillez actualiser la page. Si le problème persiste, réessayez plus tard.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                border: 'none',
                borderRadius: '18px',
                height: '44px',
                boxSizing: 'border-box',
                padding: '10px 26px',
                cursor: 'pointer',
                fontSize: '16px',
                backgroundColor: '#b9ff66',
                color: '#000000',
                fontWeight: 900,
                textTransform: 'uppercase',
              }}
            >
              Actualiser la page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
